import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { footerLinksApi } from "../../config";
import { maintenanceLink } from "../../config";
import { identity, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FooterService {
  maintenanceData: Observable<any>;

  constructor(private apiService: ApiService) {}

  postSupportRequest(body) {
    return this.apiService.post(`${footerLinksApi.postSupportRequest}`, body);
  }

  getSupportCategory(param) {
    return this.apiService.get(`${footerLinksApi.getSupportCategory}${param}`);
  }

  getMaintenanceMessage() {
    return this.apiService.get(`${maintenanceLink.getMaintenanceMessage}`);
  }

  getBannerWidgetapi() {
    return this.apiService.get(`${footerLinksApi.getBannerWidgetapi}`);
  }

  getBanners(queryParams) {
    return this.apiService.get(`${footerLinksApi.getBanner}`, queryParams);
  }

  checkUserCanAccessQuiz() {
    return this.apiService.get(`${footerLinksApi.checkUserCanAccessQuiz}`);
  }

  getQuizMetaInfo(id) {
    // return this.apiService.get(`${footerLinksApi.quizMetaInfo}${id}`);
    if (parseInt(id) !== parseInt(id))
      return this.apiService.get(`${footerLinksApi.quizMetaInfoString}${id}`);
    else
      return this.apiService.get(`${footerLinksApi.quizMetaInfoNumber}${id}`);
  }

  getQuizData(id) {
    return this.apiService.get(`${footerLinksApi.quizData}${id}`);
  }

  saveQuizAnswer(params) {
    return this.apiService.post(`${footerLinksApi.saveQuizAnswer}`, params);
  }

  submitQuiz(params) {
    return this.apiService.post(`${footerLinksApi.submitQuiz}?id=${params.id}`);
  }

  reviewQuiz(params) {
    return this.apiService.get(
      `${footerLinksApi.reviewQuiz}?quizId=${params.quizId}&userId=${params.userId}`
    );
  }

  getQuizIDbasedOnDate() {
    return this.apiService.get(`${footerLinksApi.getQuizId}`);
  }

  getSliderImages(queryParams) {
    return this.apiService.get(
      `${footerLinksApi.getSliderImages}`,
      queryParams
    );
  }
}
